import React from 'react';
import { useModalRefs } from 'src/hooks/useModalRefs';
import {
  ChildrenContainer,
  ChildrenWrapper,
} from '../StepperModal/StepperModal.styles';
import {
  ContentContainer,
  FooterContainer,
  ModalStyled,
  TitleContainer,
} from './ModalContainer.styles';

interface Props {
  open: boolean;
  children?: React.ReactNode;
  title: React.ReactNode;
  footer: React.ReactNode;
  closeModal: () => void;
  'data-testid'?: string;
  fitContent?: boolean;
  removePadding?: boolean;
}

export const ModalContainer = ({
  open,
  closeModal,
  title,
  footer,
  children,
  'data-testid': dataTestId,
  fitContent,
  removePadding = false,
}: Props) => {
  const { dialogRef, contentRef } = useModalRefs({
    closeModal,
    isOpen: open,
  });

  return (
    <ModalStyled
      show={open}
      ref={dialogRef}
      data-testid={dataTestId}
      fitContent={fitContent}
    >
      <ContentContainer ref={contentRef} fitContent={fitContent}>
        <TitleContainer removePadding={removePadding}>{title}</TitleContainer>
        <ChildrenContainer>
          <ChildrenWrapper removePadding={removePadding}>
            {children}
          </ChildrenWrapper>
        </ChildrenContainer>
        <FooterContainer removePadding={removePadding}>
          {footer}
        </FooterContainer>
      </ContentContainer>
    </ModalStyled>
  );
};
